// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

//Uncomment the two imports later when we add the auth and the firestore logic.
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: "react-firebase-basic-1eb86.appspot.com",
  messagingSenderId: "210640232896",
  appId: "1:210640232896:web:8257532fa4c1c194956825"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);

//Uncomment the two exports later when we add auth and db logic.
export const db = getFirestore(app);
export const auth = getAuth(app);